import { BrowserModule } from '@angular/platform-browser';
import { Inject, Injectable, NgModule, Optional } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  APP_BASE_HREF,
  DATE_PIPE_DEFAULT_OPTIONS,
  HashLocationStrategy,
  LocationStrategy,
  PlatformLocation,
  registerLocaleData,
} from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import en from '@angular/common/locales/en';
import { MatDialogModule } from '@angular/material/dialog';
import {
  MAT_BUTTON_CONFIG,
  MAT_FAB_DEFAULT_OPTIONS,
  MatButtonConfig,
} from '@angular/material/button';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

registerLocaleData(en);

const formFieldAppearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  color: 'primary',
};

const buttonConfig: MatButtonConfig = {
  color: 'primary',
};

@Injectable()
export class HashPreserveQueryLocationStrategy extends HashLocationStrategy {
  private readonly search: string;
  constructor(
    platformLocation: PlatformLocation,
    @Optional() @Inject(APP_BASE_HREF) _baseHref?: string
  ) {
    super(platformLocation, _baseHref);
    this.search = window.location.search || '';
  }

  prepareExternalUrl(internal: string): string {
    const hash = super.prepareExternalUrl(internal);
    return hash + this.search;
  }
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatDialogModule,
    AppRoutingModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashPreserveQueryLocationStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: formFieldAppearance },
    { provide: MAT_BUTTON_CONFIG, useValue: buttonConfig },
    { provide: MAT_FAB_DEFAULT_OPTIONS, useValue: buttonConfig },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: 'UTC' } },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],
})
export class AppModule {}
